import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["textarea", "count", "wrapper"]

  connect() {
    this.updateCount()
  }

  focus() {
    if (this.hasWrapperTarget) this.wrapperTarget.classList.add("scale-[1.02]")
  }

  blur() {
    if (this.hasWrapperTarget) this.wrapperTarget.classList.remove("scale-[1.02]")
  }

  input() {
    this.updateCount()
  }

  useExample(event) {
    const example = event.params.example?.toString() || ""
    if (!this.hasTextareaTarget) return

    this.textareaTarget.value = example
    this.updateCount()
    this.textareaTarget.focus()
  }

  updateCount() {
    if (!this.hasTextareaTarget || !this.hasCountTarget) return
    this.countTarget.textContent = `${this.textareaTarget.value.length} characters`
  }
}


